import fpApiUtil from "./fp-api-util";

const BOR = "factoryplan/master/bor/bors";
const BOR_SET = "factoryplan/master/bor/borsets";
const BOR_SET_TOOL = "factoryplan/master/bor/borsettools";
const TOOL_SUPPLY = "factoryplan/master/bor/toolsupplies";

const getBors = (params) => fpApiUtil.postParams(BOR, params);
const upsertBors = (changes) => fpApiUtil.postChanges(`${BOR}/save`, changes);
const removeBors = (changes) => fpApiUtil.postChanges(`${BOR}/delete`, changes);

const getBorSets = (params) => fpApiUtil.postParams(BOR_SET, params);
const saveBorSets = (changes) => fpApiUtil.postChanges(`${BOR_SET}/save`, changes);
const removeBorSets = (changes) => fpApiUtil.postChanges(`${BOR_SET}/delete`, changes);

const getBorSetTools = (params) => fpApiUtil.postParams(BOR_SET_TOOL, params);
const saveBorSetTools = (changes) => fpApiUtil.postChanges(`${BOR_SET_TOOL}/save`, changes);
const removeBorSetTools = (changes) => fpApiUtil.postChanges(`${BOR_SET_TOOL}/delete`, changes);

const getToolSupplies = (params) => fpApiUtil.postParams(TOOL_SUPPLY, params);
const saveToolSupplies = (changes) => fpApiUtil.postChanges(`${TOOL_SUPPLY}/save`, changes);
const removeToolSupplies = (changes) => fpApiUtil.postChanges(`${TOOL_SUPPLY}/delete`, changes);

const fpBorService = {
  getBors, upsertBors, removeBors,
  getBorSets, saveBorSets, removeBorSets,
  getBorSetTools, saveBorSetTools, removeBorSetTools,
  getToolSupplies, saveToolSupplies, removeToolSupplies,
};
export default fpBorService;
